import type { StockLotItem } from "./types";
import { normalizeExportText } from "./exportText";
import { expirationMonthValue } from "./expiration";

function csvEscape(value: string): string {
  const normalized = normalizeExportText(value);
  if (normalized.includes('"') || normalized.includes(",") || normalized.includes("\n") || normalized.includes("\r")) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }
  return normalized;
}

export function stockRowsToCsv(rows: StockLotItem[]): string {
  const header = ["stockLotId", "itemName", "catalogItemId", "binLabel", "quantity", "parQty", "expirationDate", "notes", "status"];
  const lines = [header.join(",")];

  for (const row of rows) {
    lines.push(
      [
        row.stockLotId,
        row.itemName,
        row.catalogItemId,
        row.binLabel ?? "",
        String(row.quantity),
        String(row.parQty),
        expirationMonthValue(row.expirationDate),
        row.notes ?? "",
        row.status.reason ?? ""
      ]
        .map((value) => csvEscape(value))
        .join(",")
    );
  }

  return lines.join("\n");
}
